import { useDataGridState } from "./useDataGridState.js";
const useDataGrid = (props) => {
  const [state, stateMethods] = useDataGridState(props);
  return { ...props, state, stateMethods };
};
export {
  useDataGrid
};
//# sourceMappingURL=useDataGrid.js.map
